// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { i18n } from './services/i18n-setup'
import router from './services/router'
import VueLocalStorage from 'vue-ls'
import BootstrapVue from 'bootstrap-vue'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

window._ = require('lodash');

Vue.use(BootstrapVue);

Vue.config.productionTip = false
let vueLsOptions = {
  namespace: 'rft_configurator__'
}

Vue.filter('uppercase', function (value) {
    return value.toUpperCase()
})

Vue.use(VueLocalStorage, vueLsOptions)
/* eslint-disable no-new */

Vue.use(Toast);

function loadGTM(id) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

  const f = document.getElementsByTagName('script')[0]
  const j = document.createElement('script')
  j.async = true
  j.src = `https://www.googletagmanager.com/gtm.js?id=${id}`
  f.parentNode.insertBefore(j, f)
}

const GTM_ID = process.env.GTM_ID && process.env.GTM_ID.replace(/"/g, '')
if (GTM_ID) {
  loadGTM(GTM_ID)
}

router.afterEach((to) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
      page: to.fullPath
    })
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
})





// WEBPACK FOOTER //
// ./src/main.js